import React from 'react';
import { connect } from 'react-redux';
import { getUserOrganizations, inviteUser, inviteNewUser, removeUser, reinviteUser } from "../../../../Redux/Actions/EndUser/OrganizationAction";
import { withRouter } from 'react-router';
import PortalUserForm from '../MyMemberships/AuthorizedMembers/ModalForms/PortalUserForm';
import OrganizationInviteUser from './OrganizationInviteUser';
import CircularProgress from '@material-ui/core/CircularProgress';
import SpanSpinner from '../../../Shared/SpanSpinner/SpanSpinner';

class OrganizationUsers extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
      canInvite: false,
      emailMatches: false,
      message: '',
      userModel:{},
      removeUserId: 0,
      reinviteUserId: 0,
      resetForm: false,
      touched: {
        firstName: false,
        lastName: false,
				mailingAddress1: false,
				mailingAddress2: false,
				mailingCity: false,
				state: false,
        mailingZip: false,
        phone: false,
        email: false
      },
      isActive: false
    };

    this.handleRemove = this.handleRemove.bind(this);
    this.handleReinvite = this.handleReinvite.bind(this);
  }

  componentDidMount() {
    this.props.common.emailMessage = '';

    console.log(this.props.selectedOrganization)
    if ( this.props.selectedOrganization != null )
    {
        const orgId = this.props.selectedOrganization.organizationId;
        this.props.getUserOrganizations(orgId);
    }
  }

  componentDidUpdate() {
    if (this.state.emailMatches === false && this.props.common.emailMessage === 'This email matches an email associated with a user in the portal. This invitation will be sent to that user.') {
      this.setCanInvite();
    }

    // INVITE_USER_SUCCESS updateOrganizations is set to true to update Users table
    if (this.props.updateOrganizations === true) {
      const orgId = this.props.selectedOrganization.organizationId;
      this.props.getUserOrganizations(orgId);
      this.child.reset();
      this.props.common.emailMessage = '';
    }
  }

  setCanInvite() {
    this.setState({
      canInvite: true,
      emailMatches: true
    })
  }

  portalUserStateChange = (userModel) => {
    this.props.common.emailMessage = '';
    this.setState({
      userModel: userModel,
      canInvite: false,
      emailMatches: false,
      touched: {
        firstName: false,
        lastName: false,
				mailingAddress1: false,
				mailingAddress2: false,
				mailingCity: false,
				state: false,
        mailingZip: false,
        phone: false,
        email: false
      }
    })
  }

  inviteUserStateChange = (userModel) => {
		this.setState({
      userModel: userModel,
      canInvite: true
    })
  }

  handleBlur = (field) => {
		this.setState({
			touched: { ...this.state.touched, [field]: true },
		});
  }

  handleSubmit = (event) => {
    event.preventDefault();

    if (this.props.common.emailExists) {
      // Invite existing user
      const userModel = {
        Email: this.state.userModel.email,
        // InviteeEmail: this.state.userModel.email,
        OrganizationId: this.props.selectedOrganization.organizationId
      };
      this.props.inviteUser(userModel);
    } else if (this.isModelValid()) {
      // Invite new user
      const userModel = {
        ...this.state.userModel,
        OrganizationId: this.props.selectedOrganization.organizationId,
        OrganizationName: this.props.selectedOrganization.organizationName
      }
      this.props.inviteNewUser(userModel);
    } else {
			this.setAllTouchedTrue();
		}
  }

  handleRemove(user) {
    const userModel = {
      organizationId: user.organizationId,
      userId: user.userID
    };
    this.setState({
      removeUserId: user.userID
    });
    this.props.removeUser(userModel)
  }

  handleReinvite(user) {
    const userModel = {
      organizationId: user.organizationId,
      userId: user.userID
    };
    this.setState({
      reinviteUserId: user.userID
    });
    this.props.reinviteUser(userModel)
  }

  isModelValid() {
		return this.state.userModel.firstName !== "" &&
    this.state.userModel.lastName !== "" &&
    this.state.userModel.mailingAddress1 !== "" &&
		this.state.userModel.mailingCity !== "" &&
		this.state.userModel.state.id !== 0 &&
		this.state.userModel.state.name !== "" &&
		this.state.userModel.Email !== "" &&
		this.state.userModel.mailingZip !== "";
  }

  setAllTouchedTrue() {
		this.setState({
			touched: {
        firstName: true,
        lastName: true,
				mailingAddress1: true,
				mailingAddress2: true,
				mailingCity: true,
				state: true,
        mailingZip: true,
        phone: true,
        email: true
			},
		})
	}

  render() {
    const organizationUsers = this.props.organizationUsers ? this.props.organizationUsers.map((item, i) => {
      const firstName = item.firstName !== null ? item.firstName : '';
      const lastName = item.lastName !== null ? item.lastName : '';
        return (
          <li className="list-group-item myMembershipList" key={i}>
            <div className="row">
              <label className="myMemebershipLabel listLabels col-md-4 col-lg-2">User: <label className="myMembershipListText listLabels">{`${firstName} ${lastName}`}</label>
              </label>
              <label className="myMemebershipLabel listLabels col-md-4 col-lg-4">Email Address: <label className="myMembershipListText listLabels">{item.email}</label>
              </label>
              <label className="myMemebershipLabel listLabels col-md-4 col-lg-2">Membership Id: <label className="myMembershipListText listLabels">{item.memberNumber}</label>
              </label>
            <label className="myMemebershipLabel listLabels col-md-12 col-lg-2 remove-btn">
                {item.userCanManageOrganization ? null :
                <button
                    type="button"
                    className="btnPrimary btn btn-primary"
                    onClick={() => this.handleRemove(item)}
                    disabled={this.props.removing}
                >
                    {
                        this.props.removing && this.state.removeUserId === item.userID
                            ? <SpanSpinner message="Removing" />
                            : <span>REMOVE</span>
                    }
                </button>
                }
            </label>
            <label className="myMemebershipLabel listLabels col-md-12 col-lg-2 reinvite-btn">
                {item.lastLoginTime ? null :
                <button
                    type="button"
                    className="btnSecondary btn btn-secondary"
                    onClick={() => this.handleReinvite(item)}
                    disabled={this.props.reinviting}
                >
                    {
                        this.props.reinviting && this.state.reinviteUserId === item.userID
                            ? <SpanSpinner message="Sending..." />
                            : <span>Reinvite</span>
                    }
                </button>
                }
            </label>
            </div>
          </li>

          );
      }) : "";

    return (
      <div className="organization-users">
        <form className="invite-form" onSubmit={this.handleSubmit}>

          {this.state.resetForm === false ?
            <PortalUserForm
              type={this.props.common.emailMessage === "User does not exist. Please create the user." ? 'text' : 'email'}
              portalUserStateChange={this.portalUserStateChange}
              emailLabel="Invite New User"
              message={this.state.message}
              onRef={ref => (this.child = ref)}
            />
            : null
          }

          {(this.props.common.emailMessage === "User does not exist. Please create the user.") ?
            <OrganizationInviteUser
              inviteUserStateChange={this.inviteUserStateChange}
              handleBlur={this.handleBlur}
              touched={this.state.touched}
              email={this.state.userModel.email} /> : ""}

          <button
            type="submit"
            className="btn-invite btnPrimary btn btn-primary"
            disabled={this.state.canInvite === false || this.props.inviting ? true : false}
          >
            {
              this.props.inviting
              ? <SpanSpinner message="Inviting ..." />
              : <span>Invite</span>
            }
          </button>
        </form>

        {this.props.loading ?
          <div className="card m-2 " style={{ verticalAlign: "middle", alignItems: 'center' }}>
            <CircularProgress style={{ display: 'block', margin: 'auto' }} /> <label>Loading...</label>
          </div> :
          <div className="user-list card mb-2">
            <ul className="list-group list-group-flush">{organizationUsers}</ul>
          </div>
        }

      </div>
    );
  }
}

function mapStateToProps(state) {
	return {
    common: state.common,
    loading: state.organization.loading,
    inviting: state.organization.inviting,
    organizationUsers: state.organization.organizationUsers,
    removing: state.organization.removing,
    reinviting: state.organization.reinviting,
    // selectedOrganization: state.accountDetails.selectedOrganization,
    updateOrganizations: state.organization.updateOrganizations
	};
}

export default withRouter(connect(mapStateToProps, {getUserOrganizations, inviteUser, inviteNewUser, removeUser, reinviteUser})(OrganizationUsers));
